<template>
  <v-container>
    <DashboardHeader></DashboardHeader>
    <v-row>
      <v-col align="center">
        <h1>App meldingen vorige week</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <StaafGrafiek
          :chartdata="chartdata"
          :options="options"
          class="Grafiek"
          ref="AppMeldingen"
          :height="100"
        ></StaafGrafiek>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StaafGrafiek from "@/charts/staafgrafiek.vue";
import DashboardHeader from "@/components/dashboards/components/DashboardHeader.vue";

export default {
  name: "AppmeldingDashboard",
  components: { StaafGrafiek, DashboardHeader },
  props: {},
  data: () => ({
    chartdata: {
      labels: ["Ma", "Di", "Wo", "Do", "Vr", "", "Za", "Zo"],
      datasets: [
        {
          label: "Aantal App meldingen",
          data: [],
          backgroundColor: "rgba(254,129,192, 0.8)",
          borderColor: "rgba(254,129,192, 1)",
          borderWidth: 2,
          order: 2
        },
        {
          type: "line",
          label: "Gemiddelde",
          data: [],
          fill: false,
          lineTension: 0,
          borderColor: "rgba(79,159,183, 0.9)",
          borderWidth: 3,
          order: 1
        }
      ]
    },
    options: {
      legend: {
        display: true
      },
      elements: {
        point: {
          radius: 0
        }
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            },
            ticks: { beginAtZero: true }
          }
        ],
        yAxes: [
          {
            display: true,
            scaleLabel: {
              display: true,
              labelString: "Aantal App meldingen"
            },
            ticks: { beginAtZero: true },
            gridLines: {
              drawBorder: true,
              display: true,
              lineWidth: 0
            }
          }
        ]
      }
    }
  }),
  methods: {
    loadData: function() {
      this.$api.pAppMeldingDashboard().then(response => {
        let bars = [];
        let line = [];
        for (var i = 0; i < response.data.length; i++) {
          bars.push(response.data[i].Aantal);
          line.push(response.data[i].Gem);
          if (i == 4) {
            // Ruimte tussen week en weekenddagen
            bars.push(null);
            line.push(response.data[i].Gem);
          }
        }
        this.chartdata.datasets[0].data = bars;
        this.chartdata.datasets[1].data = line;
        this.$refs.AppMeldingen.update();
      });
    }
  },
  watch: {},
  mounted() {
    this.loadData();
  }
};
</script>